module.exports = __webpack_public_path__ + "static/media/shop_anchorage_1.b944db36.svg";